'use strict';

/**
 *
 * @name: apiModulesService
 *
 */

function ApiModulesService(
  $http,
  $state,
  $localStorage,
  $rootScope,
  $q,
  translateDate
) {

  'ngInject';

  /**
   *
   * @RETURNED_METHODS
   *
   */

  function getModules(query, slugOrId, moduleType) {

    var target = $rootScope.apiUrlNew + '/module?parentType=' + query +
      (slugOrId ? '&parentSlug=' + slugOrId : '') +
      (moduleType ? '&moduleType=' + moduleType : '');

    return $http
      .get(target)
      .success(function(response) {

        angular.forEach(response.items, item => {

          const toTranslate = ['xPicks', 'xPosts', 'xSeries', 'xTopics', 'plainText', 'socialExtended', 'coverSeason', 'coverSeasonExtended', 'singleSeason', 'singleSeasonExtended', 'seasonGroup', 'seasonGroupExtended', 'allSeasonsExtended', 'pickedContributors', 'googleAd', 'newsletter', 'singlePlaylist', 'previouslyInCategory', 'playlistGroup', 'curatedByMembers', 'contributors', 'allContributors', 'contributorList', 'liveEvent', 'honourees']

          if (toTranslate.includes(item.type)) {
            if(item.type === 'xPicks'){
              item.type = 'nn-x-posts'
            } else {
              item.type = 'nn' + item.type.charAt(0).toUpperCase() + item.type.slice(1)
            }
          }

          if (item.posts.length) {

            angular.forEach(item.posts, function(post) {
              // CHINEESE 'TIMEZONE'
              post.publishDate = translateDate(post.publishDate);
            });
          }
        });
      });
  }

  function checkIfModuleHasData(module) {

    return module.jsonData.sources.some(function(item) {

      return (item.hasOwnProperty('seriesId') || item.hasOwnProperty('tagId') || item.hasOwnProperty('postId'));
    });
  }

  function getModuleQueryForApiCall(module) {

    return module.jsonData.sources.reduce(function(acc, item) {

      Object.keys(item)
        .forEach(function(key) {

          var isArray = (item[key] instanceof Array);

          acc[key] = isArray ? item[key][0] : item[key];
        });

      return acc;
    }, {});
  }

  return {
    getModules: getModules,
    checkIfModuleHasData: checkIfModuleHasData,
    getModuleQueryForApiCall: getModuleQueryForApiCall,
  };
}

export default ApiModulesService;



// WEBPACK FOOTER //
// ./app/components/_api/modules.service.js